import { Stack, Typography } from "@mui/material";
import { FC, ReactNode } from "react";

import { IconClose } from "@/modules/irohana-components/assets/icons";
import { IconBox } from "@/modules/irohana-components/elements/IconBox";
import { iconColor, text } from "@/modules/irohana-components/theme/colors-new";

export type TDialogHeaderProps = {
  title?: ReactNode;
  /** Sub text under the title. Hidden when omitted. */
  description?: ReactNode;
  enableCloseIcon?: boolean;
  onClose?: () => void;
};

export const DialogHeader: FC<TDialogHeaderProps> = ({ title, description, enableCloseIcon = true, onClose }) => {
  return (
    <Stack gap="8px" sx={{ padding: "24px 24px 16px" }}>
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap="16px">
        {typeof title === "string" ? <Typography variant="head20Bold">{title}</Typography> : title}
        {enableCloseIcon && (
          <IconBox onClick={onClose} sx={{ p: 0, ml: "auto", flexShrink: 0 }}>
            <IconClose color={iconColor.default} fontSize={24} />
          </IconBox>
        )}
      </Stack>
      {description && (
        <Typography variant="body14" sx={{ color: text.secondary }}>
          {description}
        </Typography>
      )}
    </Stack>
  );
};
